import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const FullScreenPreview = ({ image, isOpen, trigger }) => {
  const [previewSignature, setPreviewSignature] = React.useState({
    display: "none",
    rotate: 0,
    loop: 1,
  });

  React.useEffect(() => {
    document.addEventListener("click", handleSignature, true);
    return () => {
      document.removeEventListener("click", handleSignature, true);
    };
  }, []);

  React.useEffect(() => {
    if (isOpen) {
      setPreviewSignature({
        image: image,
        display: "flex",
        rotate: 0,
        loop: 1,
      });

      return () => {};
    } else {
      setPreviewSignature({
        display: "none",
        loop: 1,
      });
    }
  }, [isOpen]);

  const handleSignature = e => {
    const ids = ["header__background_previewSignature"];
    const path = e.path || (e.composedPath && e.composedPath());
    if (path[0] === document.querySelector(`#${ids[0]}`)) {
      trigger(false);
    }
  };

  return (
    <SignaturePreview
      preview={previewSignature}
      className="fade-in-custom-animate"
      id="header__background_previewSignature"
    >
      <div className="header__panel_previewSignature">
        <ul>
          <li onClick={() => trigger(false)}>
            <i className="mdi mdi-close font-size-19" />
          </li>
          <li
            onClick={() => {
              setPreviewSignature({
                ...previewSignature,
                loop:
                  previewSignature.loop + 0.3 < 4
                    ? parseFloat(previewSignature.loop + 0.3)
                    : previewSignature.loop,
              });
            }}
          >
            <i className="mdi mdi-magnify-plus-outline font-size-19" />
          </li>
          <li
            onClick={() => {
              setPreviewSignature({
                ...previewSignature,
                loop:
                  previewSignature.loop - 0.3 > 0
                    ? parseFloat(previewSignature.loop - 0.3)
                    : previewSignature.loop,
              });
            }}
          >
            <i className="mdi mdi-magnify-minus-outline font-size-19" />
          </li>
          {/* <li style={{ transform: "scaleX(-1)" }}>
            <i className="mdi mdi-format-rotate-90 font-size-19" />
          </li>
          <li>
            <i className="mdi mdi-format-rotate-90 font-size-19" />
          </li> */}
        </ul>
      </div>
      <div className="image__previewSignature" />
    </SignaturePreview>
  );
};

const SignaturePreview = styled.div`
  display: ${item => `${item.preview.display}`};
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: rgba(0, 0, 0, 0.2);

  .header__panel_previewSignature {
    position: fixed;
    top: 0;
    left: 0;
    background: white;
    width: 100%;
    height: 35px;
    vertical-align: middle;
    border-bottom: 2px solid #2a3042;
    ul {
      float: right;
      list-style: none;
      text-decoration: none;
      height: 35px;

      li {
        transition: 0.5s;
        background: rgba(0, 0, 0, 0);
        padding: 3.5px 15px;
        font-size: 18px;
        float: right;

        &:hover {
          cursor: pointer;
          background: rgba(0, 0, 0, 0.05);
        }
      }
    }
  }

  .image__previewSignature {
    position: static;
    width: 20%;
    height: 20%;
    top: 0;
    left: 0;
    margin: auto;
    background-image: ${item => `url('${item.preview.image?.preview ? item.preview.image?.preview : item.preview.image}')`};
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    transition: 1s;
    cursor: pointer;
    transform: ${item => `scale(${item.preview.loop})`};
  }
`;

FullScreenPreview.propTypes = {
  image: PropTypes.any,
  isOpen: PropTypes.bool,
  trigger: PropTypes.func.isRequired,
};

export default FullScreenPreview;
